module.exports = __webpack_public_path__ + "img/roedkaal_start.33b35a94.jpg";